import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { InvoicingDatesCardComponent } from '@app/feature/invoice/invoice-details/tabs/information-tab/cards/invoicing-dates-card.component';

import { InvoiceLinesDetailsView } from '../../../invoice-lines-details/invoice-lines-details.view';
import { InformationCardComponent } from './cards/information-card.component';
import { TotalCardComponent } from './cards/total-card.component';

export const InformationTabComponent = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.M} flex={1} direction="column">
      <InvoicingDatesCardComponent />

      <Stack
        flex={1}
        gap={GapEnum.M}
        justifyContent="space-between"
        direction="column">
        <Stack gap={GapEnum.M} direction="column">
          <InformationCardComponent />
          <InvoiceLinesDetailsView />
        </Stack>
        <TotalCardComponent />
      </Stack>
    </Stack>
  );
};
